import {DirectionTypes, FilterType, FilterValue, LogicalOperator, StatusTypes} from '../../types/models'

export type GeneratePromptTemplate = {
  prompt_id?: string
  text: string
}

export type PromptTemplateSpecField = {
  description?: string
  filter_type?: 'select' | 'range' | 'boolean' | 'text' | 'date' | 'none'
  filterable?: boolean
  filter_options?: string[] | {min?: number; max?: number; step?: number}
  key?: string
  label?: string
  type?: 'string' | 'number' | 'boolean' | 'text'
}

export type PromptTemplateSpec = {
  fields?: PromptTemplateSpecField[]
  template_description?: string
  template_name?: string
  user_facing_prompt?: string
  user_raw_promt?: string
}

export type PromptTemplate = {
  id?: string
  name?: string
  description?: string
  text?: string
  schema?: Record<string, any>
  spec?: PromptTemplateSpec
  is_active?: boolean
  is_main?: boolean
}

export const initialNewPrompt: PromptTemplate = {
  name: '',
  description: '',
  text: '',
  is_active: true,
  is_main: false,
}

export type LlmAnalysis = {
  model?: string
  status?: string
  result?: Record<string, any>
  prompt_templates?: PromptTemplate
}

type CompanyInfo = {
  id: number
  title: string
}

export type ClientInfo = {
  id: number
  type: string
  name: string
  company?: CompanyInfo
}

export type Stt = {
  text?: string
  segments?: Record<string, any>
  emo?: Record<string, any>
  stt_model?: string
}

export type DataCDR = {
  id: string
  call_start: string
  call_finish: string
  status: 'ANSWERED' | 'NO ANSWER' | 'BUSY' | 'FAILED' | 'CANCELLED'
  direction: DirectionTypes
  from_: string
  to_: string
  did_number?: string
  record_url?: string
  dial_duration: number
  talk_duration: number
  llm_analysis?: LlmAnalysis
  stt?: Stt
  client_info?: ClientInfo
}

export type FilterOp =
  | '$eq'
  | '$ne'
  | '$lt'
  | '$lte'
  | '$gt'
  | '$gte'
  | '$in'
  | '$not_in'
  | '$like'
  | '$not_like'
  | '$between'
  | '$starts_with'
  | '$ends_with'

export const FILTER_OP: Record<string, FilterOp> = {
  eq: '$eq',
  ne: '$ne',
  lt: '$lt',
  lte: '$lte',
  gt: '$gt',
  gte: '$gte',
  inArray: '$in',
  notInArray: '$not_in',
  iLike: '$like',
  notILike: '$not_like',
  isBetween: '$between',
  startsWith: '$starts_with',
  endsWith: '$ends_with',
}

export interface FilterRule {
  id: string
  column: keyof DataCDR
  type: FilterType
  operator: string
  value: FilterValue
}

export interface IFilterQueryCDR {
  sort_by?: string
  period?: string
  status?: StatusTypes
  direction?: DirectionTypes
  offset?: number
  limit?: number
  search?: string
  rules?: {
    operator: LogicalOperator
    items: FilterRule[]
  } | null
  rules_llm?: {
    operator: LogicalOperator
    prompt_id?: string
    items: {fieldKey: string; operator: string; value: any}[]
  } | null
}

export interface IRequestCDRData {
  id: string
  filter: IFilterQueryCDR
  account_id?: string
}

export interface ICDRUser {
  id?: string
  number: string
  name: string
}

export interface ICDRLine {
  id?: string
  number: string
  name: string
}

export interface ICDRUserList {
  users: ICDRUser[]
}

export interface ICDRLineList {
  lines: ICDRLine[]
}

export interface ColumnMeta {
  key: keyof DataCDR
  label: string
  type: FilterType
}

export type CDREntitiesState = {
  users: ICDRUser[]
  lines: ICDRLine[]
}

export type CDREntitiesContextProps = {
  state: CDREntitiesState
  setUsers: (users: ICDRUser[]) => void
  setLines: (lines: ICDRLine[]) => void
}
